/* global indexUrl */

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import { formatFigure, formatMoney } from 'Helpers/formatService';

const figure = (value) => formatFigure(value, formatMoney, { precision: 3 });

export default function PurchaseOrderReportingIndex(props) {
    const [isLoading, setIsLoading] = useState(true);
    const [purchaseOrdersList, setPurchaseOrdersList] = useState([]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        setIsLoading(true);
        axios
            .get(indexUrl)
            .then((res) => {
                setPurchaseOrdersList(res.data.purchaseOrders);
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <div className="inbud-table_wrapper">
            <table className="inbud-table">
                <thead>
                    <tr>
                        <th>Unique ID</th>
                        <th>Budget Code</th>
                        <th>Price</th>
                        <th>Requested By</th>
                        <th>Status</th>
                        <th>Supplier</th>
                        <th>Supplier Location</th>
                        <th>Supplier Postcode</th>
                        <th>Contract Reference</th>
                    </tr>
                </thead>
                <tbody>
                    {purchaseOrdersList.map((order) => {
                        return (
                            <tr key={order.id}>
                                <td>{order.code}</td>
                                <td dangerouslySetInnerHTML={{ __html: order.budget_codes }}></td>
                                <td className="inbud-numeric-cell">{figure(order.price)}</td>
                                <td>{order.requested_by}</td>
                                <td>{order.status}</td>
                                <td>{order.supplier}</td>
                                <td>{order.supplier_location}</td>
                                <td>{order.supplier_postcode}</td>
                                <td>{order.contract_reference}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

if (document.getElementById('purchaseOrdersReporting')) {
    const root = document.getElementById('purchaseOrdersReporting');
    ReactDOM.render(
        <App>
            <PurchaseOrderReportingIndex />
        </App>,
        root,
    );
}
